import { proxy } from "valtio";
import { devtools } from "valtio/utils";

const ENV_DEV = "dev";
const ENV_RECETTE = "recette";

type ModeleTicketStoreType = {
    firstModelBlackBackground: boolean;
    firstModelSmallerFont: boolean;
    secondModelSingleLabel: boolean;
    secondModelOnlineOrder: boolean;
    secondModelMenuComponent: boolean;
    secondModelNameMenu: boolean;
    threedModelFollowKitchenTicket: boolean;
    threedModelFontSmall: boolean;
    threedModelDispatchAutomaticallyFollow: boolean;
    threedModelActivateManualDispatchFollow: boolean;
    threedModelOrderKitchen: boolean;
    threedModelSendChangesKitchen: boolean;
    threedModelTicketAdditionsCancellations: boolean;
};

const MODELE_TICKET_DEFAULTS: ModeleTicketStoreType = {
    firstModelBlackBackground: false,
    firstModelSmallerFont: false,
    secondModelSingleLabel: false,
    secondModelOnlineOrder: false,
    secondModelMenuComponent: false,
    secondModelNameMenu: false,
    threedModelFollowKitchenTicket: false,
    threedModelFontSmall: false,
    threedModelDispatchAutomaticallyFollow: false,
    threedModelActivateManualDispatchFollow: false,
    threedModelOrderKitchen: false,
    threedModelSendChangesKitchen: false,
    threedModelTicketAdditionsCancellations: false,
};

export const modeleTicketStore = proxy<ModeleTicketStoreType>({
    ...MODELE_TICKET_DEFAULTS,
});

if (
    process.env.REACT_APP_VERIFY === ENV_DEV ||
    process.env.REACT_APP_VERIFY === ENV_RECETTE
) {
    devtools(modeleTicketStore);
}

export function setFirstModelBlackBackground(value: boolean): void {
    modeleTicketStore.firstModelBlackBackground = value;
}
export function setFirstModelSmallerFont(value: boolean): void {
    modeleTicketStore.firstModelSmallerFont = value;
}
export function setSecondModelSingleLabel(value: boolean): void {
    modeleTicketStore.secondModelSingleLabel = value;
}
export function setSecondModelOnlineOrder(value: boolean): void {
    modeleTicketStore.secondModelOnlineOrder = value;
}
export function setSecondModelMenuComponent(value: boolean): void {
    modeleTicketStore.secondModelMenuComponent = value;
}
export function setSecondModelNameMenu(value: boolean): void {
    modeleTicketStore.secondModelNameMenu = value;
}
export function setThreedModelFollowKitchenTicket(value: boolean): void {
    modeleTicketStore.threedModelFollowKitchenTicket = value;
}
export function setThreedModelFontSmall(value: boolean): void {
    modeleTicketStore.threedModelFontSmall = value;
}
export function setThreedModelDispatchAutomaticallyFollow(
    value: boolean
): void {
    modeleTicketStore.threedModelDispatchAutomaticallyFollow = value;
}
export function setThreedModelActivateManualDispatchFollow(
    value: boolean
): void {
    modeleTicketStore.threedModelActivateManualDispatchFollow = value;
}
export function setThreedModelOrderKitchen(value: boolean): void {
    modeleTicketStore.threedModelOrderKitchen = value;
}
export function setThreedModelTicketAdditionsCancellations(
    value: boolean
): void {
    modeleTicketStore.threedModelTicketAdditionsCancellations = value;
}
export function setThreedModelSendChangesKitchen(value: boolean): void {
    modeleTicketStore.threedModelSendChangesKitchen = value;
}

export function resetModeleTicketStore(): void {
    Object.assign(modeleTicketStore, MODELE_TICKET_DEFAULTS);
}
